import React, { Component } from "react";
import Slider from "react-slick";
import "./index.scss";
import styles from "./index.module.scss";

function SampleNextArrow(props) {
  const { onClick } = props;
  return (
    <div className={`${styles.arrow} ${styles.nextArrow}`} onClick={onClick}>
      <img src="/images/right_arrow.png" alt="" />
    </div>
  );
}

function SamplePrevArrow(props) {
  const { onClick } = props;
  return (
    <div className={`${styles.arrow} ${styles.prevArrow}`} onClick={onClick}>
      <img src="/images/left_arrow.png" alt="" />
    </div>
  );
}

export default class SimpleSlider extends Component {
  render() {
    let { videoList, ambulance, handleSelectVideo, selectedItem } = this.props;
    const settings = {
      dots: false,
      infinite: false,
      speed: 500,
      vertical: true,
      verticalSwiping: true,
      swipeToSlide: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      initialSlide: 0,
      nextArrow: <SampleNextArrow />,
      prevArrow: <SamplePrevArrow />
    };
    return (
      <div style={videoList.length <= 3 ? { width: "100%", height: "100%", overflow: "hidden" }: { width: "100%" }}>
        {videoList.length > 0 ? (
          <Slider {...settings}>
            {videoList.map(item => (
              <div key={item.id}>
                <div
                  className={`${styles.slider_container} slider_container`}
                  onClick={() => handleSelectVideo(item)}
                >
                  <img src={ambulance + item.photo} alt="" />
                  {selectedItem.id === item.id ? (
                    <div className={styles.name}>{item.name}</div>
                  ) : null}
                </div>
              </div>
            ))}
          </Slider>
        ) : null}
      </div>
    );
  }
}
